/**
 * EntrepreneursHub — Batch #14.313 : le module Entrepreneurs est fusionné dans Tenue de livres.
 * Cette route ne sert plus qu'à rediriger les anciens liens (/admin/entrepreneurs?master_id=…) vers le hub Tenue de livres.
 */
import { Navigate, useSearchParams } from "react-router-dom";

export default function EntrepreneursHub() {
  const [sp] = useSearchParams();
  const mid = sp.get("master_id");
  return <Navigate to={`/admin/tenue-livres${mid ? `?master_id=${mid}` : ""}`} replace />;
}
